import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class DisbursementsExportService {

  private readonly batchTableUrl = environment.main_url + "/agilelegal/export"
  private readonly downloadbatchUrl = environment.main_url + "/agilelegal/export/disbursementTasks/batch"

  constructor(private readonly http: HttpClient) { }
  getAllBatchList(payload:any){
    return this.http.post<any>(this.batchTableUrl+"/filter",payload)
  }
  getAllBatchListPages(pageNumber: any, pageSize: any,payload:any){
    return this.http.post<any>(this.batchTableUrl+"/disbursementTasks/filter?pageNumber=" + pageNumber + "&pageSize=" + pageSize,payload)
  }
  generateExportData(){
    return this.http.post<any>(this.batchTableUrl+"/v2/disbursementTasks",{})
  }
  downloadBatch(batchId:any){
    return this.http.get(this.downloadbatchUrl + "/" + batchId,{ responseType: 'arraybuffer', observe: 'response' })
  }
}
